export default __webpack_public_path__ + "bd0af70538e9e0fda19dcc7da6f33f87.svg";